import * as React from 'react'
import PropTypes from 'prop-types'
import Badge from '../Badge'

const actionPriorityColorMap = {
  "Low": "blue", // 0
  "Medium": "yellow", // 1
  "High": "red", // 2
}

const ActionPriorityBadge = ({
  value: valueProp,
}) => {
  const value = React.useMemo(() => {
    if (typeof valueProp === 'number') {
      return ['Low', 'Medium', 'High'][valueProp]
    }
    return valueProp
  }, [valueProp])

  if (!valueProp && valueProp !== 0) return null; // -1

  return <Badge
    value={value}
    colorName={actionPriorityColorMap[value]}
    isFlex
  />
}

ActionPriorityBadge.propTypes = {
  value: PropTypes.oneOf([-1, 0, 1, 2, "High", "Medium", "Low"])
}

export default ActionPriorityBadge